var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 104,
    viewBox: "0 0 137 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57445 97.1669L8.12796 96.2426C8.41257 96.0734 8.36886 95.6176 8.06092 95.5142L6.37041 94.9478L6.04133 93.0498C5.98142 92.7034 5.56842 92.6071 5.38477 92.8956L4.36869 94.4738L2.61513 94.231C2.29726 94.1858 2.08428 94.5845 2.27731 94.8635L3.33372 96.4038L2.57624 98.1461C2.43675 98.4627 2.71757 98.8065 3.02349 98.6923L4.70018 98.0671L5.98678 99.3898C6.22128 99.6307 6.60648 99.4471 6.60095 99.0937L6.57445 97.1669Z",
    fill: "#FBCD83",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M127.091 16.2058L131.221 19.3818C131.978 19.9638 132.994 19.2675 132.85 18.277L132.052 12.8404L136.101 9.53018C136.84 8.92648 136.546 7.6512 135.636 7.50154L130.645 6.65091L129.007 1.44582C128.713 0.500765 127.507 0.408057 127.094 1.29877L124.803 6.19043L119.752 6.26901C118.832 6.27801 118.377 7.49575 119.031 8.20655L122.613 12.1034L121.123 17.3642C120.852 18.3227 121.769 19.1676 122.593 18.7071L127.091 16.2058Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.501 84.3957L128.666 82.8542C129.429 82.5721 129.5 81.4359 128.786 81.0399L124.869 78.868L124.805 74.0683C124.794 73.1924 123.82 72.7647 123.258 73.3857L120.153 76.778L115.955 75.3691C115.194 75.1107 114.517 75.9881 114.881 76.7607L116.865 81.0223L114.329 84.9365C113.864 85.6466 114.417 86.619 115.211 86.4813L119.56 85.7293L122.193 89.5652C122.673 90.2638 123.688 89.9932 123.813 89.1256L124.501 84.3957Z",
    fill: "#FD4954"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6271 91.6309L48.2537 90.2886C48.9181 90.043 48.98 89.0537 48.3587 88.7088L44.9474 86.8175L44.8919 82.6381C44.8821 81.8754 44.0344 81.5029 43.5446 82.0437L40.8412 84.9976L37.1854 83.7707C36.5231 83.5458 35.9333 84.3098 36.2499 84.9826L37.9778 88.6935L35.7699 92.1018C35.3648 92.7202 35.8464 93.5669 36.5375 93.4471L40.3249 92.7922L42.6176 96.1325C43.0356 96.7408 43.9193 96.5051 44.0278 95.7496L44.6271 91.6309Z",
    fill: "#FFC362"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.7545 29.7872C25.1915 29.9141 25.6539 29.8901 26.0779 29.7185C26.5018 29.5469 26.8665 29.2361 27.1216 28.8291C27.3776 28.4095 27.5127 27.9167 27.5075 27.4121L27.3915 24.1138C27.367 23.2848 27.5199 22.4611 27.8383 21.7078C28.1566 20.9545 28.6315 20.2924 29.2254 19.7739L31.6363 17.7092C31.987 17.3869 32.2361 16.9528 32.3485 16.4681C32.4609 15.9833 32.4309 15.4723 32.2627 15.0072C32.0946 14.542 31.7968 14.146 31.4113 13.8751C31.0257 13.6042 30.572 13.4719 30.1138 13.497L27.0832 13.6229C26.3224 13.6502 25.5663 13.4839 24.8748 13.137C24.1833 12.7901 23.5755 12.2723 23.0997 11.6247L21.2037 9.00485C20.9122 8.62377 20.5189 8.35121 20.0787 8.22507C19.6384 8.09894 19.173 8.12551 18.7473 8.30108C18.3215 8.47666 17.9566 8.79251 17.7032 9.2047C17.4498 9.61689 17.3206 10.1049 17.3335 10.6009L17.4494 13.965C17.4671 14.7741 17.3159 15.5769 17.0072 16.3129C16.6984 17.0489 16.2403 17.6988 15.6673 18.2134L13.2562 20.271C12.9068 20.589 12.657 21.0177 12.5414 21.4975C12.4257 21.9773 12.45 22.4845 12.6108 22.9486C12.7717 23.4127 13.0611 23.8107 13.4389 24.0874C13.8167 24.364 14.2642 24.5056 14.7192 24.4924L17.7457 24.3608C18.5099 24.3341 19.2692 24.5031 19.9627 24.854C20.6563 25.205 21.2647 25.7283 21.7391 26.3818L23.6373 29.0081C23.9269 29.3888 24.3183 29.6604 24.7545 29.7872Z",
    fill: "#0560FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M56.8089 44.2646C56.8922 44.4382 57.0229 44.5793 57.1829 44.6684C57.3429 44.7576 57.5243 44.7905 57.7022 44.7625C57.8836 44.7315 58.0523 44.6422 58.1864 44.5049L59.041 43.5817C59.2571 43.3512 59.5194 43.1787 59.8072 43.0779C60.0951 42.977 60.4005 42.9507 60.6993 43.0009L61.9015 43.2154C62.0823 43.2407 62.2658 43.2036 62.4262 43.1092C62.5865 43.0148 62.7157 42.868 62.7955 42.6893C62.8752 42.5107 62.9015 42.3093 62.8707 42.1135C62.8399 41.9177 62.7535 41.7374 62.6237 41.5979L61.7756 40.6648C61.5639 40.4294 61.4054 40.1434 61.3128 39.8296C61.2202 39.5157 61.1959 39.1827 61.242 38.8569L61.4362 37.548C61.4602 37.3526 61.4278 37.1539 61.3434 36.9796C61.259 36.8052 61.1268 36.6638 60.9652 36.5752C60.8037 36.4865 60.6208 36.4549 60.4421 36.4848C60.2633 36.5147 60.0975 36.6046 59.9678 36.7419L59.0954 37.6828C58.8829 37.9058 58.6267 38.0733 58.3461 38.1725C58.0655 38.2717 57.7678 38.3001 57.4757 38.2556L56.2753 38.039C56.0961 38.013 55.9138 38.0485 55.7539 38.1405C55.5939 38.2325 55.4643 38.3765 55.3828 38.5525C55.3014 38.7286 55.2723 38.9278 55.2995 39.1227C55.3267 39.3176 55.4089 39.4984 55.5347 39.64L56.3831 40.5704C56.5956 40.807 56.7543 41.0947 56.8463 41.4103C56.9384 41.7259 56.9614 42.0606 56.9133 42.3876L56.718 43.6988C56.6936 43.8935 56.7258 44.0913 56.8089 44.2646Z",
    fill: "#FFC362"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2313_21174)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2313_21174)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#0660FC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2313_21174)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 34,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9785 50.1504L76.2798 57.8491L72.0217 53.591",
    stroke: "#0660FC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2313_21174",
    x: 32,
    y: 8,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2313_21174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2313_21174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2313_21174",
    x: 48,
    y: 24,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.0784314 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2313_21174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2313_21174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2313_21174"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupSuccess);
export default __webpack_public_path__ + "static/media/popup_success.ac5f8e387bbc8762a367f930e8d20a74.svg";
export { ForwardRef as ReactComponent };